import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { roleHome } from './roleHome';

export default function CustomerUsersRoute({ children }) {
  const { session } = useAuth();
  const role = String(session?.role || '').toLowerCase();
  if (role !== 'customer') return <Navigate to={roleHome(role)} replace />;
  if (session?.canManageCustomerUsers !== true) return <Navigate to="/fleet_dashboard" replace />;
  return children;
}
